import { createSlice } from "@reduxjs/toolkit";

import {
  chequePayment,
  downloadInvoice,
  getBuyerPaymentsList,
} from "../../../thunks/buyer-thunks/BuyerThunks";
import { message } from "antd";

const initialState = {
  isLoading: false,
  downloadInvoicePdf: null,
  error: null,
};

export const buyerPayementSlice = createSlice({
  name: "buyerPayments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Download invoice as pdf for payments
    builder
      .addCase(downloadInvoice.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(downloadInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.downloadInvoicePdf = action.payload;
      })
      .addCase(downloadInvoice.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    // Fetching Buyer Payments list
    builder
      .addCase(getBuyerPaymentsList.pending, (state) => {
        state.isPaymentsLoading = true;
        state.error = null;
      })
      .addCase(getBuyerPaymentsList.fulfilled, (state, action) => {
        state.isPaymentsLoading = false;
        state.buyerPaymentsList = action.payload;
      })
      .addCase(getBuyerPaymentsList.rejected, (state, action) => {
        state.isPaymentsLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    builder
      .addCase(chequePayment.pending, (state) => {
        state.isPaymentsLoading = true;
        state.error = null;
      })
      .addCase(chequePayment.fulfilled, (state, action) => {
        state.isPaymentsLoading = false;
        state.buyerPaymentsList = action.payload;
      })
      .addCase(chequePayment.rejected, (state, action) => {
        state.isPaymentsLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });
  },
});

export default buyerPayementSlice.reducer;
